<template>
  <div class="col-md-4 mb-1 mb-md-0">
    <div class="d-flex">
      <h2 class="my-0">
        {{ title != '' ? capitalize($t(title)) : capitalize($t($route.name)) }}
      </h2>
      <small v-if="itemsContext.list_global_amount != null" class="ml-2 my-auto" style="padding-top: 3px;">
        ({{ totalResults }}) {{ currency(itemsContext.list_global_amount) }}
      </small>
      <small v-else class="ml-2 my-auto" style="padding-top: 3px;">
        {{ totalResults }} {{ $tc('resultFound', totalResults) }}
      </small>
    </div>

  </div>
</template>

<script>
import { ref, computed, watch } from '@vue/composition-api'
import { capitalize, currency } from '../../../utils/filter'

export default {
  components: {},
  props: {
    title: {
      type: String
    },
    items: {
      type: Array,
      default: () => []
    },
    itemsContext: {
      type: Object,
      default: () => {}
    },
    displayCustomFields: {
      type: Boolean,
      default: true
    },
  },
  setup (props) {
    // ------------------------------------------------
    // Data
    // ------------------------------------------------

    // ------------------------------------------------
    // Computed
    // ------------------------------------------------
    const totalResults = computed(() => {
      return ('total_results' in props.itemsContext)?props.itemsContext.total_results:0
    })

    // ------------------------------------------------
    // Watch
    // ------------------------------------------------

    // ------------------------------------------------
    // Methods
    // ------------------------------------------------

    // ------------------------------------------------
    // Mounted
    // ------------------------------------------------

    // ------------------------------------------------
    // Setup
    // ------------------------------------------------
    return {
      // Components
      capitalize,
      currency,

      // Data

      // Computed
      totalResults,

      // Methods
    }
  },
  data () {
    return {}
  },
  computed: {},
  watch: {},
  methods: {},
  mounted () {
  },
  created () {
  }
}
</script>

<style
    scoped
    lang="scss"
>

</style>